const retrieveAffiliateInfoFromStorage = () => {
  const affiliateData = window.localStorage.getItem('gems_affiliate');

  return affiliateData ? JSON.parse(affiliateData) : { affiliateId: '' };
};

export default retrieveAffiliateInfoFromStorage;



// WEBPACK FOOTER //
// ./src/utils/localStorage.js